'use strict'

module.exports = {
  GET_RECORD_BY_INDEX: 'GET_RECORD_BY_INDEX',
  SET_FIELDS_IN_CURRENT_RECORD: 'SET_FIELDS_IN_CURRENT_RECORD',
  REVERT_CHANGES: 'REVERT_CHANGES',
  CALL_BEFORE_SAVE_HOOKS: 'CALL_BEFORE_SAVE_HOOKS',
  CHECK_DRAFT: 'CHECK_DRAFT',
  SAVE_RECORD: 'SAVE_RECORD',
  REMOVE_RECORD: 'REMOVE_RECORD',
  NEW_RECORD: 'NEW_RECORD'
}



// WEBPACK FOOTER //
// ./records/cmdTypes.js